export interface IDeviceDetailsResponse {
    eid: string;
    manufacturer: string;
}

export interface IDeviceDetailsPayload {
    eid: string;
    manufacturer: string;
    type: string;
}

export interface IDevicesResponse {
    manufacturers: string[];
}

export const getPostDeviceDetailsPayload = (eid: string, manufacturer: string): IDeviceDetailsPayload => ({
    eid,
    manufacturer,
    type: "SmartPhone",
});
